import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import { getElementalTypes } from '~~/src/api/elementals'
import type { GetReturn } from '~~/src/types/utils'

export const useElementalElementalTypesQuery = (
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getElementalTypes>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getElementalTypes>, Error> => {
  const types = useElementalTypes()

  return useQuery({
    queryKey: ['elemental-types'] as const,
    queryFn: async () => {
      const result = await getElementalTypes()
      if (result)
        types.value = result
      return result
    },
    ...options,
  })
}
